<template>
   <section class="walletHistory-wrap pb-3">
      <template v-if="transactionDetails != null && transactionDetails.status != 0">
         <div class="payment-history" :class="['reject_in_process','reject_completed','expired','cancelled'].includes(transactionDetails.status) ? 'payment-rejected' : (transactionDetails.status == 'hold' ? 'payment-pending' : '')" >
            <div class="payment-iocn payment-approved">
                  <img v-if="['approve_completed','approve_in_process'].includes(transactionDetails.status)" src="@/assets/images/payment-approved.svg" alt="payment-approved" loading="lazy">
                  <img v-if="['reject_in_process','reject_completed','expired', 'cancelled'].includes(transactionDetails.status)" src="@/assets/images/payment-rejected.svg" alt="payment-rejected" loading="lazy">
                  <img v-if="['hold'].includes(transactionDetails.status)" src="@/assets/images/hold_icon.svg" alt="payment-processing" loading="lazy">
            </div>
            <div class="request_title">
                  <h3>{{ transactionDetails?.user_name }}</h3>
                  <p>{{ transactionDetails?.type?.includes('deposit') ? 'Deposit' : 'Withdrawal'}} Request {{transactionDetails?.status.includes('approve') ? 'Approved' : (transactionDetails?.status.includes('reject') ? 'Rejected' : (transactionDetails?.status.includes('cancelled') ? 'Cancelled' : 'In Process'))}}</p>
            </div>
         </div>
         <div class="container">
               <div class="historyDet-wrap">
                  <div class="historyDet-items">
                        <div class="historyDet-item">
                           <span class="historyDet-key">{{$t('requested-amount', 'Requested Amount')}}</span>
                           <span class="historyDet-value">{{ transactionDetails.amount }}</span>
                        </div>
                        <div class="historyDet-item" v-if="['approve_completed','approve_in_process'].includes(transactionDetails.status)">
                           <span class="historyDet-key">{{$t('accepted-amount', 'Accepted Amount') }}</span>
                           <span class="historyDet-value">{{ transactionDetails?.approved_amount || '0.00' }}</span>
                        </div>
                        <div class="historyDet-item">
                           <span class="historyDet-key">{{$t('request-date', 'Request Date')}}</span>
                           <span class="historyDet-value">{{ transactionDetails?.created_at ? $dateTime.getLocalDate(transactionDetails?.created_at, 'DD MMM YYYY hh:mm:ss A') : '-'}}</span>
                        </div>
                        <div class="historyDet-item">
                           <span class="historyDet-key">{{$t('action-on', 'Action on')}}</span>
                           <span class="historyDet-value">{{ transactionDetails?.action_at ? $dateTime.getLocalDate(transactionDetails?.action_at, 'DD MMM YYYY hh:mm:ss A') : '-'}}</span>
                        </div>
                        <div class="historyDet-item">
                           <span class="historyDet-key">{{$t('reference-no', 'Reference No.')}}</span>
                           <span class="historyDet-value">{{ transactionDetails?.transaction_id || '-'}}</span>
                        </div>
                        <div class="historyDet-item">
                           <span class="historyDet-key">{{$t('remarks', 'Remarks')}}</span>
                           <span class="historyDet-value">{{ transactionDetails?.remark || '-' }}</span>
                        </div>
                        <!-- <span class="historyDet-value" :class="item?.type == 2 ? 'statusDeposit' : 'statusWithdraw'">{{ item?.type == 2 ? "Deposit" : "Withdraw" }}</span> -->
                        <!-- <div class="historyDet-item">
                           <span class="historyDet-key">Status</span>
                           <span class="historyDet-value status-type">{{ item?.status }}</span>
                        </div> -->
                  </div>
                  <div class="withdraw-fix-sec continue-btn">
                        <!-- <span class="withdraw-btn deposit-btn">
                           <a href="#walleteditstackModal" data-bs-toggle="modal" class="thm-but">
                              <span><img loading="lazy" src="@/assets/images/edit-icon.svg" alt="edit-icon"></span>
                              <span>{{$t('edit-stake', 'Edit Stake')}}</span>
                           </a>
                        </span>
                        <a href="javascript:void(0);" class="thm-but" id="account-successfully" data-bs-toggle="modal" data-bs-target="#instructionsModal">{{ $t('proceed','Proceed') }} </a> -->
                        <div class="view-details" v-if="transactionDetails?.transaction_image_url">
                           <button type="button" class="thm-but back_btn_link" data-bs-toggle="modal" data-bs-target="#transactionModal">{{ $t('view-details','View details') }}</button>
                        </div>
                        <div class="button-whatsapp" v-if="$siteSettings.data && $siteSettings.data?.social_link && $siteSettings.data?.social_link.whatsappno1">
                           <a type="button" class="btn-whatsapp" :href="'//wa.me/' + $siteSettings.data.social_link.whatsappno1" target="_blank">
                              <img src="@/assets/images/whatsapp.png" alt="whatsapp" />
                              {{ $t('customer-support','Customer support') }}
                           </a>
                        </div>
                  </div>
               </div>        
         </div>
      </template>
   </section>
    <!-- transaction details modal -->
    <div class="modal fade history-filter-modal transaction_detail_modal" id="transactionModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
         <div class="modal-content">
            <div class="modal-header">
               <div class="thm-heading">
                  <h3>{{ $t('details','Details') }}</h3>
               </div>
               <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
               <div v-if="transactionImageLists?.length">
                  <div class="row my-2" style="align-items: center;" >
                     <div :class="transactionImageLists?.length > 1 ? 'col-6' : 'col-12'" v-for="(image, index) in transactionImageLists" :key="index">
                           <div>
                              <a :href="image" download target="_blank">
                                 <img :src="image" height="100%" alt="transaction-list" width="100px" />
                              </a>
                           </div>
                     </div> <br>
                     <div class="col-7">
                        <!-- <p v-if="data.remarks">
                           {{ $t('remarks','Remarks') }} :- {{ data.remarks }}
                        </p> -->
                     </div>
                     <div class="col-2">
                           <p>{{ getImageBy(transactionDetails.type) }}</p>
                     </div>
                  </div>
               </div>
               <div v-else>
                  <p class="text-center" style="color: #000;">{{ $t('no-record-found','No Record found') }}</p>
               </div>
            </div>
         </div>
      </div>
   </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { createComputedPropertiesForTransactionDetails } from '@template/utils'

export default {
   name: 'TransactionDetails',
   data(){
      return{
         transactionId: null,
      }
   },
   computed:{
      ...mapGetters(['transactionDetails']),
      ...{}
   },
   beforeCreate() {
        let {transactionImageLists} = createComputedPropertiesForTransactionDetails(this);
        this.$helper.applySharedComputed(this, {transactionImageLists})
   },
   mounted(){
      this.transactionId = this.$route?.params?.id
   },
   methods:{
      toTitleCaseWithSpaces(str) {
         return str.split('_').map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(' ');
      },
      getTransactionStatus(status){
            switch (status) {
               case 0 :
                  return 'Pending';
               case 1 :
                  return 'Approved';
               case 2 :
                  return 'Rejected';
               case 3 :
                  return 'Canceled';
               case 4 :
                  return 'Closed';
            }
      },
      generateUID(length) {
         return window.btoa(String.fromCharCode(...window.crypto.getRandomValues(new Uint8Array(length * 2)))).replace(/[+/]/g, "").substring(0, length);
      },
      getRemarks(requestImages) {
         var remark = '';
         remark = requestImages.find(e => e.remarks != null);
         if (remark) {
               remark = remark.remarks;
         }
         return remark;
      },
      getImageBy(data) {
         if (data == 2) {
            return "By me";
         } else if (data == 3) {
            return "By Admin";
         } 
      },
   }
}
</script>

<style scoped>
.btn-whatsapp:hover{
   color: #fff;
}
.historyDet-value{
   word-wrap: break-word;
}
</style>